import { gql } from '@apollo/client';

export const GET_REQUIRED_SCAN_ASSIGNMENT = gql`
  query findRequiredScanDocumentAssignmentEntity {
    findRequiredScanDocumentAssignmentEntity {
      id
      appointment {
        description
        date
      }
    }
  }
`;
